import React, {FunctionComponent} from "react";
import {Link, makeStyles, Typography} from "@material-ui/core";

type UnderlinedTextButtonProps = {
    text: string;
    fontSize?: number
    onClick?: () => void;
    href?: string;
    target?: string;
};

const useStyles = makeStyles((theme) => ({text: {color: theme.palette.text.primary}}));

const UnderlinedTextButton: FunctionComponent<UnderlinedTextButtonProps> = ({text, fontSize, href, onClick}) => {
    const classes = useStyles();
    return (
        <Typography style={{fontSize}}>
            <Link onClick={onClick} color={"secondary"} href={href} target={"_blank"} underline={"always"}
                  className={classes.text}>
                {text}
            </Link>
        </Typography>
    );
};

export default UnderlinedTextButton;
